import type { StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const getImportTypename = (importType: string, legalEntityName?: string): string => {
  if (importType === 'employee_importer')
    return i18n.t('universal_importer.import_history.table.types.employee_importer', {
      legalEntityName,
    })
  if (importType === 'cost_center_assignment_importer')
    return i18n.t(
      'universal_importer.import_history.table.types.cost_center_assignments_importer',
      {
        legalEntityName,
      }
    )
  if (importType === 'employee_edition')
    return i18n.t('universal_importer.import_history.table.types.employee_edition')
  if (importType === 'employee_bulk_termination_importer')
    return i18n.t(
      'universal_importer.import_history.table.types.employee_bulk_termination_importer'
    )
  if (importType === 'fd_contract_importer')
    return i18n.t('universal_importer.import_history.table.types.fd_contract_importer')
  if (importType === 'candidates_importer')
    return i18n.t('universal_importer.import_history.table.types.candidates_importer')
  if (importType === 'ats_job_posting_importer')
    return i18n.t('universal_importer.import_history.table.types.ats_job_posting_importer')
  if (importType === 'compensations_employee_compensation_importer')
    return i18n.t(
      'universal_importer.import_history.table.types.compensations_employee_compensation_importer'
    )
  if (importType === 'payroll_summary_importer')
    return i18n.t('universal_importer.import_history.table.types.payroll_summary_importer')
  if (importType === 'competencies_competency_importer')
    return i18n.t('universal_importer.import_history.table.types.competencies_competency_importer')
  if (importType === 'competencies_competency_assignment_importer')
    return i18n.t(
      'universal_importer.import_history.table.types.competencies_competency_assignment_importer'
    )
  if (importType === 'it_management_it_assets_importer')
    return i18n.t('universal_importer.import_history.table.types.it_management_it_assets_importer')
  if (importType === 'job_catalog_tree_importer')
    return i18n.t('universal_importer.import_history.table.types.job_catalog_tree_importer')
  if (importType === 'contract_version_edition')
    return i18n.t('universal_importer.import_history.table.types.contract_version_edition', {
      legalEntityName,
    })
  if (importType === 'teams_importer')
    return i18n.t('universal_importer.import_history.table.types.teams_importer')

  return importType
}

export const percentageLabel = (processed: number, total: number) => {
  const percentage = total > 0 ? Math.round((processed / total) * 100) : 0
  return i18n.t('universal_importer.import_history.table.progress.percentage', {
    percentage,
  })
}

export const processedRowsLabel = (processed: number, total: number) => {
  const percentage = total > 0 ? Math.round((processed / total) * 100) : 0
  if (percentage === 100)
    return i18n.t('universal_importer.import_history.table.progress.content_100_percentage')
  return i18n.t('universal_importer.import_history.table.progress.content_with_percentage', {
    processed,
    total,
    percentage,
  })
}

type StatusObject = {
  status: StatusVariant
  label: string
}

export const mapStatus = (status: string): StatusObject => {
  switch (status) {
    case 'pending':
      return {
        status: 'neutral',
        label: i18n.t('universal_importer.import_history.table.statuses.pending'),
      }
    case 'completed_with_errors':
      return {
        status: 'warning',
        label: i18n.t('universal_importer.import_history.table.statuses.completed_with_errors'),
      }
    case 'processing':
      return {
        status: 'info',
        label: i18n.t('universal_importer.import_history.table.statuses.processing'),
      }
    case 'finished':
      return {
        status: 'positive',
        label: i18n.t('universal_importer.import_history.table.statuses.finished'),
      }
    case 'error':
      return {
        status: 'critical',
        label: i18n.t('universal_importer.import_history.table.statuses.error'),
      }
    default:
      return {
        status: 'neutral',
        label: i18n.t('universal_importer.import_history.table.statuses.unknown'),
      }
  }
}

export const mapStatusToVariant = (status: string): StatusVariant => {
  if (status === 'pending') return 'neutral'
  if (status === 'finished') return 'positive'
  if (status === 'error') return 'critical'
  if (status === 'completed_with_errors') return 'warning'
  return 'neutral'
}
